import { InjectionToken } from '@angular/core';

export const ELM_SVG_ICON_SET = new InjectionToken<string>(
  'ELEMENT451 SVG ICON SET'
);
